import { Col, FormGroup, FormLabel, Row } from "react-bootstrap";
import InputText from "../../../components/Forms/Element/InputText";
import StatusCheckBox from "../../../components/Common/StatusCheckbox";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { convertStatusToBoolean } from "../../../../utils/ConverterUtils";
import CnpjInput from "../../../components/Common/CnpjInput";
import AddressRegistration from "../../../components/Custom/Common/Address/AddressRegistration";
import { formatCNPJ } from "../../../../utils/FormatUtils";
import AsteriskRequired from "../../../components/Common/AsteriskRequired";
import FormSection from "../../../components/Common/Form/FormSection";
import BranchWorkingHoursEditor from "./BranchWorkingHoursEditor";

const Form = (props) => {

    const { t } = useTranslation();
    const { status, setStatus, formik, entityData, onWorkingHoursChange } = props;

    useEffect(() => {
        // Preenche os valores nos campos.
        if (entityData != null) {
            formik.setFieldValue('name', entityData.name);
            formik.setFieldValue('document', entityData.document ? formatCNPJ(entityData.document) : '');

            if (entityData.address !== null) {
                formik.setFieldValue('street', entityData.address.street);
                formik.setFieldValue('number', entityData.address.number);
                formik.setFieldValue('complement', entityData.address.complement);
                formik.setFieldValue('neighborhood', entityData.address.neighborhood);
                formik.setFieldValue('city', entityData.address.city);
                formik.setFieldValue('state', entityData.address.state);
                formik.setFieldValue('zipCode', entityData.address.zipCode);
            }

            setStatus(convertStatusToBoolean(entityData.status));
        }

        // eslint-disable-next-line
    }, [entityData]);

    return (
        <>
            <div className="form-layout form-layout--spaced">
                <FormSection
                    title={t('basic_information')}
                    description="Defina os dados principais da filial para identificação e uso interno."
                    icon="fa-solid fa-building"
                >
                    <Row className="g-3">
                        <Col md={6}>
                            <FormGroup>
                                <FormLabel>{t('name')} <AsteriskRequired /></FormLabel>
                                <InputText
                                    name="name"
                                    placeholder={t('name_placeholder')}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.name}
                                    error={formik.errors.name}
                                    maxlenght="50"
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <FormLabel>{t('cnpj')}</FormLabel>
                                <CnpjInput
                                    name="document"
                                    placeholder={t('document')}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.document}
                                    error={formik.errors.document}
                                    maxlenght="30"
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </FormSection>

                <FormSection
                    title={t('address.label')}
                    description="Organize localização, CEP e complemento para facilitar atendimento e operação."
                    icon="fa-solid fa-location-dot"
                >
                    <AddressRegistration formik={formik} />
                </FormSection>

                <FormSection
                    title={t('status')}
                    description="Controle se a filial está ativa para uso nas rotinas do sistema."
                    icon="fa-solid fa-toggle-on"
                    compact
                >
                    <Row>
                        <Col md={12}>
                            <FormGroup className="mb-0">
                                <StatusCheckBox
                                    name="status"
                                    defaultChecked={status}
                                    checked={status}
                                    onClick={() => setStatus(!status)} />
                            </FormGroup>
                        </Col>
                    </Row>
                </FormSection>

                {entityData?.id && (
                    <FormSection
                        title={t('working_hours')}
                        description={t('working_hours_description')}
                        icon="fa-solid fa-clock"
                    >
                        <BranchWorkingHoursEditor branchId={entityData.id} onChange={onWorkingHoursChange} />
                    </FormSection>
                )}
            </div>
        </>
    );
}

export default Form;
